import useAutoSave, { UseAutoSaveProps } from './hooks/useAutoSave';

const AutoSave = (props: UseAutoSaveProps) => {
    useAutoSave(props);
    return null;
};
export default AutoSave;
